import { Injectable } from '@angular/core';
import { ApiService } from './Api.service';

@Injectable({
  providedIn: 'root'
})
export class ActiveCampaignService {

  url = 'ac';
  baseDataUrl = 'data';
  lessonStatusUrl = 'lesson_status';
  coursesListUrl = 'public/list/courses';
  contactUrl = 'contact';
  subscribeUrl = 'subscription';
  reviewUrl = 'review';
  finishedCoursesUrl = 'public/list/finished';

  constructor(private apiService: ApiService) {
  }
  async addTagToContact(email,tag) {
    try {
         const data = {
        email: email,
        tag:tag
      }
    
      const resp = await this.apiService.post(this.url + '/addTagToContact',data);
      return resp;
    } catch (error) {
      return error;
    }
  }
  async removeTagToContact(email,tag) {
    try {
         const data = {
        email: email,
        tag:tag
      }
    
      const resp = await this.apiService.post(this.url + '/removeTagToContact',data);
      return resp;
    } catch (error) {
      return error;
    }
  }
  
  async registerContactForm(firstName,lastName,email,tag='',phone='') {
    try {
         const data = {
          email: email,
          firstName:firstName,
          lastName:lastName,
          tag:tag,
          phone:phone
      }
      const resp = await this.apiService.post(this.url + '/registercontactform',data);
      return resp;
    } catch (error) {
      return error;
    }
  }
  async registerContact(firstName,lastName,email) {
    try {
         const data = {
          email: email,
          firstName:firstName,
          lastName:lastName
      }
      const resp = await this.apiService.post(this.url + '/registercontact',data);
      return resp;
    } catch (error) {
      return error;
    }
  }
}
